import {
  AGENT_TOPIC_COLLECTIONS,
  AGENT_TOPIC_CUSTOM,
  AGENT_TOPIC_INQUIRIES,
  AGENT_TOPIC_MAINTENANCE,
  AGENT_TOPIC_SALES,
  AGENT_TOPIC_SOURCEPROPERTIES,
  PIPELINE_ID_COLLECTIONS,
  PIPELINE_ID_DEFAULT,
  PIPELINE_ID_GENERAL,
  PIPELINE_ID_MAINTENANCE,
  PIPELINE_ID_SOURCEPROPERTIES,
} from "../../../agent/src/common/types";

export const mapPipelinePositionId = {
  new: "Nuevo",
  delivered: "Entregado",
  read: "Leído",
  answered: "Respondido",
  redirected: "Redirección humano",
  appointmentIntent: "Intención de cita",
  appointmentPending: "Pre-cita",
  appointmentConfirmed: "Cita confirmada",
  appointmentCancelled: "Cita cancelada",
  closed: "Negocio Cerrado",
  discarded: "Descartado",
  inactive: "Inactivo",
};

export const mapSource = {
  ciencuadras: "Ciencuadras",
  fincaraiz: "Finca Raíz",
  metrocuadrado: "Metro Cuadrado",
  web: "Página web inmobiliaria",
  direct: "Directo a WhatsApp",
  mercadolibre: "Mercado Libre",
  webinmobiliaria: "Web Inmobiliaria",
  proppit: "Proppit",
  // Leads created manually by an advisor from the portal (conversations.start).
  dashboard: "Creado manualmente",
};

export const mapStage = {
  new: "Prospecto",
  pending: "En Gestión",
  success: "Resuelto",
  failure: "Descartado",
};

export const mapType = {
  ai_agent: "Agente",
  customer: "Usuario",
};

export const mapPipelineName: Record<string, string> = {
  [PIPELINE_ID_DEFAULT]: "Comercial",
  [PIPELINE_ID_SOURCEPROPERTIES]: "Captación",
  [PIPELINE_ID_MAINTENANCE]: "Mantenimiento",
  [PIPELINE_ID_GENERAL]: "Administrativo",
  [PIPELINE_ID_COLLECTIONS]: "Cartera",
};

// Ticket (service request) statuses — raw fallback because statuses can be
// merchant-custom (e.g. "escalado").
export const mapTicketStatus: Record<string, string> = {
  new: "Nuevo",
  in_progress: "En progreso",
  closed_success: "Cerrado exitoso",
  blocked: "Bloqueado",
  closed_failure: "Cerrado sin éxito",
};

export const mapLeadType = {
  inbound: "Inbound",
  outbound: "Outbound",
  pauta: "Pauta",
  "inbound-email": "Correo",
};

export const mapAgentTopic: Record<string, string> = {
  [AGENT_TOPIC_SOURCEPROPERTIES]: "Captación",
  [AGENT_TOPIC_SALES]: "Comercial",
  [AGENT_TOPIC_MAINTENANCE]: "Mantenimiento",
  [AGENT_TOPIC_INQUIRIES]: "Administrativo",
  [AGENT_TOPIC_CUSTOM]: "Personalizado",
  [AGENT_TOPIC_COLLECTIONS]: "Cartera",
};
